import classNames from 'classnames'
import React, { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { selectRoadbookSummary } from '../../store/itinerary/expenseReport.selectors'
import { selectCurrentProvider } from '../../store/itinerary/itinerary.selectors'
import { selectPreferredFuel, selectPreferredVehicle } from '../../store/itineraryOptions/itineraryOptions.selectors'
import { noop } from '../../utils/function'
import RectangleActionButton, { COLOR_GREEN, SIZE_MEDIUM } from '../genericComponents/buttons/RectangleActionButton'
import NumericInput from '../genericComponents/NumericInput'
import T from '../i18n/T'
import s from './ExpenseReport.less'
import useComputeExpenseReportCost from './useComputeExpenseReportCost'

const ExpenseReportCostSection = () => {
  const modeId = useSelector(selectCurrentProvider)
  const vehicle = useSelector(selectPreferredVehicle(modeId))
  const fuel = useSelector(selectPreferredFuel(modeId))
  const summary = useSelector(selectRoadbookSummary)
  const { compensationByKm, compensationTotal, totalAmount, setCompensationByKm } = useComputeExpenseReportCost()

  const onCompensationByKmChanged = useCallback((e) => setCompensationByKm(e.target.value), [])

  return (
    <>
      <div className={s.block}>
        <h2>
          <T id={'itinerary.expense.price-title'} />
        </h2>
        <div>
          <strong>
            <T id={'itinerary.expense.price-vehicle'} />
          </strong>{' '}
          : {vehicle?.label}
        </div>
        <hr className={s.smallBar} />
        <div>
          <strong>
            <T id={'itinerary.expense.price-fuel'} />
          </strong>{' '}
          : {fuel && `${fuel.label} (${fuel.price} ${fuel.price_unit})`} - {summary?.gas?.label}
        </div>
        <hr className={s.smallBar} />
        <div>
          <strong>
            <T id={'itinerary.expense.price-toll'} />
          </strong>{' '}
          : {summary?.toll?.label}
        </div>
        <hr className={s.smallBar} />
        <div>
          <strong>
            <T id={'itinerary.expense.compensation-title'} />
          </strong>
          <NumericInput
            value={compensationByKm}
            step="0.01"
            onBlur={onCompensationByKmChanged}
            onChange={onCompensationByKmChanged}
          />
          <span>€/km</span>
          <span> ({compensationTotal} €)</span>
        </div>
      </div>
      <div className={classNames(s.block, s.actions)}>
        <RectangleActionButton
          color={COLOR_GREEN}
          iconId="crayon-ios"
          label="itinerary.expense.compute"
          onClick={noop}
          size={SIZE_MEDIUM}
        />
      </div>
      <div className={classNames(s.block, s.total)}>
        <T id={'itinerary.expense.total'} /> {totalAmount} €
      </div>
    </>
  )
}

export default ExpenseReportCostSection
